/* eslint-disable @typescript-eslint/no-unused-expressions */
import * as React from "react";
import { Table, Thead, Tbody, Tr, Th, Td, chakra, HStack, Button, Menu, MenuButton, IconButton, MenuList, MenuItem } from "@chakra-ui/react";
import { DeleteIcon, DownloadIcon, EditIcon, HamburgerIcon, TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  ColumnDef,
  SortingState,
  getSortedRowModel,
  getPaginationRowModel,
  getFilteredRowModel,
  Column
} from "@tanstack/react-table";
import Pagination from "./Pagination";
import { downloadExcel } from "react-export-table-to-excel"

export type DataTableProps<Data extends object> = {
  data: Data[];
  columns: ColumnDef<Data, any>[];
  name: string;
  editMode;
  onEdit;
  onDelete: any;
  onOpen: any;
  onOpenAlert;
};

export function DataTable<Data extends object>({
  data,
  columns,
  name,
  editMode,
  onEdit,
  onDelete,
  onOpen,
  onOpenAlert
}: DataTableProps<Data>) {
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    state: {
      sorting
    }
  });

  
  const exportArr : any = [];

  table.getRowModel().rows.map((row) => {
   
    exportArr.push(row.original)
  })



  function handleDownloadExcel() {

    const header = ['ID', 'Vardas', 'Pavarde', 'Korteles Nr.', 'Kortelės Gr.', 'Duru ID', 'Kryptis','Data ir laikas', 'Veiksmas']

    downloadExcel({
      fileName: `EECO Access Log - ${new Date().toLocaleString('lt-LT')}`,
      sheet: "Access Log",
      tablePayload: {
        header,
        body: exportArr,
      },
    });
  }

  return (
    <>
    {name !== 'hide' && 
    <HStack mx={'1rem'}>
      <Button leftIcon={<DownloadIcon/>} colorScheme={'blue'} w={'12rem'}  onClick={handleDownloadExcel}>{name}</Button>
    </HStack>
    }
    <Pagination 
    table={table}
    totalProducts={data.length}
    productsPerPage={20}
    />
    <Table width={'95%'} margin={'0 auto'} fontSize={'md'} variant='striped' colorScheme='gray'>
      <Thead>
        {table.getHeaderGroups().map((headerGroup, index) => (
          <Tr key={index}>
            {headerGroup.headers.map((header, index) => {
              // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
              const meta: any = header.column.columnDef.meta;
              return (
                <>
                <Th key={index}
                  >
                <Th
                onClick = {header.column.getToggleSortingHandler()}
                isNumeric={meta?.isNumeric}>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                     
                  <chakra.span pl="4">
                    {header.column.getIsSorted() && header.getContext().header.id !== 'actions' ? (
                      header.column.getIsSorted() === "desc" ? (
                        <TriangleDownIcon aria-label="sorted descending" />
                      ) : (
                        <TriangleUpIcon aria-label="sorted ascending" />
                      )
                    ) : null}
                  </chakra.span>
                  
                </Th>
                {header.column.getCanFilter() && header.getContext().header.id !== 'actions' ? (
                          <div>
                            <Filter column={header.column} table={table} />
                          </div>
                        ) : null}
                </Th>
                </>
              );
            })}
          </Tr>
        ))}
      </Thead>
      <Tbody>
        
        {table.getRowModel().rows.map((row, index) => (
          <Tr key={index}>
            {row.getVisibleCells().map((cell, index) => {
              // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
              const meta: any = cell.column.columnDef.meta;
              
             
              return (
                cell.getContext().column.id !== 'actions' ?
                <Td key={index} isNumeric={meta?.isNumeric}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </Td> :
                <Td key={index} isNumeric={meta?.isNumeric}>
                <Menu>
                      <MenuButton marginLeft={'2rem'}
                        as={IconButton}
                        aria-label='Options'
                        icon={<HamburgerIcon />}
                        variant='outline'
                      />
                      <MenuList>
                        <MenuItem onClick={() => { onEdit(row.original); editMode(true); onOpen(); }} icon={<EditIcon />}>
                          Redaguoti
                        </MenuItem>
                        <MenuItem onClick={() => { onDelete(row.original.id); onOpenAlert();}} color={'red.500'} icon={<DeleteIcon />}>
                          Ištrinti
                        </MenuItem>
                      </MenuList>
                    </Menu>
              </Td>
              )
             
            })}
          </Tr>
        ))}
      </Tbody>
    </Table>
    <Pagination 
    table={table}
    totalProducts={data.length}
    productsPerPage={20}
    />
    </>
  );
}

function Filter({
    column,
    table,
  }: {
    column: Column<any, any>
    table: ReactTable<any>
  }) {
    const firstValue = table
      .getPreFilteredRowModel()
      .flatRows[0]?.getValue(column.id)
  
    const columnFilterValue = column.getFilterValue()
    
    return (
      <input
        type="text"
        value={(columnFilterValue ?? '') as string}
        onChange={e => {e.stopPropagation(); column.setFilterValue(e.target.value); }}
        placeholder={`Ieskoti...`}
        className="w-36 border shadow rounded"
      />
    )
  }